import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	shareButtonText: {
		id: 'share.button.text',
		defaultMessage: 'Share',
	},
});
